{
  "de": {
    "marketplace_partner": {
      "contact_me": {
        "success": "Wir werden uns in Kürze bei Ihnen melden.",
        "failure": "Ein unerwarteter Fehler ist aufgetreten.",
        "button": "Kontaktieren Sie mich!"
      }
    }
  }
}
